const NotificacionesElectronicas = {
    GuardaElCorreoElectronicoInstitucional: "PaginaOficial/NotificacionesElectronicas/GuardaElCorreoElectronicoInstitucional"
}

const ConsultaDeAbogados = {
    ObtenAbogadosRegistrados: "PaginaOficial/ConsultaDeAbogados/ObtenAbogadosRegistrados",
    ObtenerNumeroDeAbogadosRegistrados: 'PaginaOficial/ConsultaDeAbogados/ObtenerNumeroDeAbogadosRegistrados'
}

const funcion = {
    ConsultaDeAbogados: ConsultaDeAbogados, 
    NotificacionesElectronicas: NotificacionesElectronicas
  }
  
export default funcion;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/PaginaOficial/funcion/funcion.js
// module id = null
// module chunks = 